import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import Grid from '@material-ui/core/Grid';

export const FavouriteGridConatainer = styled(Grid)`
    color: blue;
    padding: 27px 18px;
    ${media.smalDevice`
        padding: 27px 12px;
    `}
    ${media.mobileDevice`
        display:none;
    `}
`;
export const AccountContainer = styled.span`
    position: absolute;
    right: 3px;
    background: #ffffff;
    color: blue;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    ${media.mobileDevice`
        margin-top:12px;
        display:block;
    `}
`;
export const FavouriteIcon = styled.img.attrs((props) => ({
    src: props.mobilePath,
}))`
    width: 24px;
    height: 24px;
    display: block;
    cursor: pointer;
`;
export const FavoriteIconDesktopContainer = styled.div`
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 2px #00000029;
    border: 1px solid #ebebeb;
    border-radius: 6px;
    opacity: 1;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;

    justify-content: center;
    margin-right: ${({ marginRight }) => marginRight};
    ${media.smalDevice`
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 2px #00000029;
    border: 1px solid #ebebeb;
    border-radius: 6px;
    opacity: 1;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;

    justify-content: center;
    margin-right: ${({ marginRight }) => marginRight};
`};
    ${media.mobileDevice`
        display:none;
    `};
`;
export const FavoriteIconMobileContainer = styled.div`
    display: none;
    ${media.mobileDevice`
        background: #ffffff 0% 0% no-repeat padding-box;
        box-shadow: 0px 0px 2px #00000029;
        border: 1px solid #ebebeb;
        border-radius: 6px;
        opacity: 1;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: ${({ marginRight }) => marginRight};
    `};
`;

export const HeaderGridContainer = styled(Grid)`
    width: 1096px;
    height: 48px;
    position: sticky;
    top: 0px;
    z-index: 0;
    padding-top: 12px;
    padding-left: 20px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 1px 2px #00000029;
    border: 1px solid #dcdcdc;
    border-radius: 6px 6px 0px 0px;
    opacity: 1;
    ${media.smalDevice`
    position: sticky;
    top: 0;
    z-index: 0;
    padding-left: 10px;
`}
    ${media.mobileDevice`
        display:none !important;
    `}
`;
export const HeaderTextContainer = styled(Grid)`
    text-align: left;
    font-family: 'AvenirNextWorld Demi';
    font-size: 13px;
    letter-spacing: 0px;
    padding-left: 8px;
    color: #3c3c3c;
    opacity: 0.7;
    width: 89px;
    height: 22px;
    ${media.smalDevice`    
    padding-left: 15px;
    `}
`;
export const AccountGridContainer = styled(Grid)`
    width: 1096px;
    min-height: 78px;
    background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    opacity: 1;
    margin-top: 10px;
    ${media.mobileDevice`  
        box-shadow: 0px 0px 4px #00000029; 
    `}
`;
export const AccountNameGrid = styled(Grid)`
    text-align: left;
    font-size: 15px;
    font-family: AvenirNextWorld Demi;
    letter-spacing: -0.12px;
    color: #1010eb;
    opacity: 1;
    padding: 30px 30px;
    cursor: pointer;
    ${media.smalDevice`    
    padding:24px 23px 0px 30px;
        display: inherit;
        justify-content: space-between;
    `}
    ${media.mobileDevice`  
    padding: 20px 18px 0px 24px;         
    `}
    .account-name-content {
        ${media.mobileDevice`  
            max-width: 280px;
        `}
    }
`;
export const AccountNumberDesktopGrid = styled(Grid)`
    text-align: left;
    font-family: AvenirNextWorld Regular;
    font-size: 15px;
    letter-spacing: -0.12px;
    color: #140f4b;
    opacity: 1;
    padding: 30px 22px;
    ${media.smalDevice`    
    padding: 30px 30px;
`}
    ${media.mobileDevice`    
        
        display:none;
    `}
`;
export const AccountNumberMobileGrid = styled(Grid)`
    display: none;
    ${media.mobileDevice`  
    display:flex;
    text-align: left;
    font-family: AvenirNextWorld Regular;
    
    letter-spacing: -0.12px;
    color: #140f4b;
    opacity: 1;  
        padding:0px 25px;
       
    `};
`;
export const CityGrid = styled(Grid)`
    text-align: left;
    font-family: 'AvenirNextWorld Regular';
    font-size: 12px;
    letter-spacing: -0.1px;
    color: #726f93;
    padding: 30px 19px;
    ${media.smalDevice`
        padding: 27px 23px;
    `}
    ${media.mobileDevice`    
        padding:0px 25px !important;
    `}
`;

export const StyledSortIcon = styled.div`
    width: 18px;
    height: 16px;
    margin: auto;
    margin-right: 8px;
`;
export const DistrictGrid = styled(Grid)`
    padding: 27px 18px;
    ${media.smalDevice`    
        padding: 25px 23px;
    `}
    ${media.mobileDevice`    
        padding:0px 22px 0px 25px !important;
        margin-bottom: 12px !important;
    `}
`;

export const DitrictNameContainer = styled.span`
    text-align: left;
    font-family: AvenirNextWorld Demi;
    font-size: 14px;
    letter-spacing: -0.11px;
    color: #140f4b;
    word-break: break-word;
`;
export const TerritoryNameContainer = styled.span`
    text-align: left;
    font-family: AvenirNextWorld Regular;
    font-size: 14px;
    letter-spacing: -0.11px;
    color: #140f4b;
    word-break: break-word;
`;
export const MoreItemView = styled.div`
    margin: 2.25px 0px 0px 8px;
    color: #1010eb;
    font-size: 11px;
    font-family: 'AvenirNextWorld Regular';
    cursor: pointer;
`;
export const MoreContainer = styled.p`
    font-family: AvenirNextWorld Regular;
    font-size: 11px;
    letter-spacing: -0.09px;
    color: #1010eb;
    opacity: 1;
    text-align: left;
    cursor: pointer;
`;
export const SortIcon = styled.span`
    margin-left: 10px;
    cursor: pointer;
`;

export const AccountDetailsContainer = styled.div`
    display: block;
    width: 100%;
    height: 100%;
    position: relative;
    -webkit-overflow-scrolling: touch;
    ${media.smalDevice`
        height: calc(112% - 103px);
    `}
    ${media.mobileDevice`
        height: calc(112% - 103px);
        overflow: hidden;
    `}
`;

export const MainSubContainer = styled.div`
    width: 100%;
    height: auto;
    padding-bottom: ${(props) =>
        props.showDoubleBanner
            ? '240px'
            : props.showSingleBanner
            ? '160px'
            : '120px'};

    @media screen and (min-device-width: 1360px) and (max-device-width: 1370px) and (min-device-height: 1020px) and (max-device-height: 1130px) and (orientation: landscape) {
        padding-bottom: 200px;
    }

    @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {  
        padding-bottom: 200px;
    }

    @media screen and (min-device-width: 990px) and (max-device-width: 1100px) and (orientation: landscape) {  
        padding-bottom: 200px;
    }

    @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {  
        padding-bottom: 200px;
    }

    @media only screen and (min-width: 1110px) and (max-width: 1122px) and (orientation: landscape) {
        padding-bottom: 200px;
    }

    ${media.mediumDevice`
        padding-bottom: 180px;
    `}
    
    ${media.smalDevice`
        padding-bottom: 180px;
    `}

    ${media.mobileDevice`
        height: auto;
        width:auto;
        margin-top: 0%;
        padding-bottom: 280px;
    `}
`;
export const AccountNumberHeader = styled.span`
    ${media.mobileDevice`
    text-align: left;
    font-family: 'AvenirNextWorld Regular';
    font-size:14px;
    letter-spacing: -0.11px;
    color: #140F4B;
    opacity: 1;
    `}
`;
export const AccountNumberSpan = styled.span`
    ${media.mobileDevice`
     text-align: left;
     font-family: AvenirNextWorld Regular;
     font-size : 15px;
     letter-spacing: -0.12px;
     color: #140F4B;
     opacity: 1;
     margin-left:4px;
    `}
`;
export const ClearFilterText = styled.span`
    font-family: ${({ isDemi }) =>
        isDemi ? 'AvenirNextWorld Demi' : 'AvenirNextWorld Regular'};
    cursor: ${({ isDemi }) => (isDemi ? 'pointer' : 'unset')};
    font-size: 16px;
    color: ${({ isDemi }) => (isDemi ? '#1010eb' : '#140F4B')}; ;
`;
export const AccountDetailsModalBackdrop = styled.div`
    #more-accounts-account-details-modal .ModalWebConatiner > div:first-child {
        background-color: rgb(47, 45, 70, 0.63) !important;
    }
`;